module.exports = __webpack_public_path__ + "static/media/frf.b63fb63c.svg";